module.exports = __webpack_public_path__ + "img/ddlogo.64e86aef.png";